import React from 'react';
import { COMPANY_FEATURE_FLAGS } from '@app/constants/company';
import { useIsFeatureFlag } from '@app/hooks/general/useIsFeatureFlag';
import CategoryHSCodeComponent from './CategoryHSCodeComponent';
import { CategoryHSCodeProvider } from './context';
import { CategoryHSCodeSelectionProps } from './types';

export function CategoryHSCodeSelection(props: CategoryHSCodeSelectionProps) {
  const { onChange, value, is10DigitCodeEnabled, ...rest } = props;

  const is10DigitEnabledByFlag = useIsFeatureFlag(COMPANY_FEATURE_FLAGS.HS_CODE_10_DIGIT);

  return (
    <CategoryHSCodeProvider
      onChange={onChange}
      value={value}
      is10DigitCodeEnabled={is10DigitCodeEnabled && is10DigitEnabledByFlag}
    >
      <CategoryHSCodeComponent {...rest} />
    </CategoryHSCodeProvider>
  );
}

export default CategoryHSCodeSelection;
